module.exports = __webpack_public_path__ + "static/media/speed_limit.115abb17.svg";